// El nombre de un chofer como se muestra en todo el panel: nombre y
// apellido, o el usuario si no los cargó. `fallback` es para cuando no hay
// chofer (o ni usuario): «—» en una tabla, «sin chofer» en un tooltip.
export type NamedDriver = { username?: string | null; first_name?: string | null; last_name?: string | null };

export const driverName = (d: NamedDriver | null | undefined, fallback = "—"): string =>
  (d ? [d.first_name, d.last_name].filter(Boolean).join(" ") || d.username : null) || fallback;
